<template>
    <!-- Title -->
    <div   class="">
      <h2 style="word-spacing:16px; letter-spacing: 9px " 
          class="text-center"
          v-text="HorsSportGeorgia"></h2>   
     
    </div>
</template>

<script>
import headerSubTitle from './headerSubTitleJSON/en-headerSubTitle.json';
export default {
  data(){
        return{
          // Get JSON object from imported file
          headerSubTitle,
          HorsSportGeorgia: headerSubTitle.HorsSportGeorgia
        }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/EN-vers/Header/headerSubTitle.vue